// KYC 民族字段（5.1）本地兜底翻译；线上真实翻译走 CDN（MTS），本地仅在 CDN 失效时兜底
// NOTE: MTS 录入为独立 ops 步骤，需运营/翻译团队在 MTS 后台补齐 `Setting` group 下的 56 个 KYCEthnic<key> 词条（不含 KO）
export const Setting = {
    KYCEthnic: '民族',
    'KYCEthnicCN-ETH-HA': '汉族',
    'KYCEthnicCN-ETH-MG': '蒙古族',
    'KYCEthnicCN-ETH-HU': '回族',
    'KYCEthnicCN-ETH-ZA': '藏族',
    'KYCEthnicCN-ETH-UG': '维吾尔族',
    'KYCEthnicCN-ETH-MH': '苗族',
    'KYCEthnicCN-ETH-YI': '彝族',
    'KYCEthnicCN-ETH-ZH': '壮族',
    'KYCEthnicCN-ETH-BY': '布依族',
    'KYCEthnicCN-ETH-CS': '朝鲜族',
    'KYCEthnicCN-ETH-MA': '满族',
    'KYCEthnicCN-ETH-DO': '侗族',
    'KYCEthnicCN-ETH-YA': '瑶族',
    'KYCEthnicCN-ETH-BA': '白族',
    'KYCEthnicCN-ETH-TJ': '土家族',
    'KYCEthnicCN-ETH-HN': '哈尼族',
    'KYCEthnicCN-ETH-KZ': '哈萨克族',
    'KYCEthnicCN-ETH-DA': '傣族',
    'KYCEthnicCN-ETH-LI': '黎族',
    'KYCEthnicCN-ETH-LS': '傈僳族',
    'KYCEthnicCN-ETH-VA': '佤族',
    'KYCEthnicCN-ETH-SH': '畲族',
    'KYCEthnicCN-ETH-GS': '高山族',
    'KYCEthnicCN-ETH-LH': '拉祜族',
    'KYCEthnicCN-ETH-SU': '水族',
    'KYCEthnicCN-ETH-DX': '东乡族',
    'KYCEthnicCN-ETH-NX': '纳西族',
    'KYCEthnicCN-ETH-JP': '景颇族',
    'KYCEthnicCN-ETH-KG': '柯尔克孜族',
    'KYCEthnicCN-ETH-TU': '土族',
    'KYCEthnicCN-ETH-DU': '达斡尔族',
    'KYCEthnicCN-ETH-ML': '仫佬族',
    'KYCEthnicCN-ETH-QI': '羌族',
    'KYCEthnicCN-ETH-BL': '布朗族',
    'KYCEthnicCN-ETH-SL': '撒拉族',
    'KYCEthnicCN-ETH-MN': '毛南族',
    'KYCEthnicCN-ETH-GL': '仡佬族',
    'KYCEthnicCN-ETH-XB': '锡伯族',
    'KYCEthnicCN-ETH-AC': '阿昌族',
    'KYCEthnicCN-ETH-PM': '普米族',
    'KYCEthnicCN-ETH-TA': '塔吉克族',
    'KYCEthnicCN-ETH-NU': '怒族',
    'KYCEthnicCN-ETH-UZ': '乌孜别克族',
    'KYCEthnicCN-ETH-RS': '俄罗斯族',
    'KYCEthnicCN-ETH-EW': '鄂温克族',
    'KYCEthnicCN-ETH-DE': '德昂族',
    'KYCEthnicCN-ETH-BN': '保安族',
    'KYCEthnicCN-ETH-YG': '裕固族',
    'KYCEthnicCN-ETH-GI': '京族',
    'KYCEthnicCN-ETH-TT': '塔塔尔族',
    'KYCEthnicCN-ETH-DR': '独龙族',
    'KYCEthnicCN-ETH-OR': '鄂伦春族',
    'KYCEthnicCN-ETH-HZ': '赫哲族',
    'KYCEthnicCN-ETH-MB': '门巴族',
    'KYCEthnicCN-ETH-LB': '珞巴族',
    'KYCEthnicCN-ETH-JN': '基诺族',
};
